import React, { useEffect, useState, useCallback } from "react";
import { useHistory } from "react-router-dom";
import { InfoCircleOutlined, PlusOutlined, UploadOutlined, DownloadOutlined } from "@ant-design/icons";
import { Button, Card, Col, Row, Table, Space, Upload } from "antd";
import Filter from "../../../components/filter/Filter";
import { useDispatch, useSelector } from "react-redux";
import {
  deletePerson,
  getPersonByType,
  exportPersons,
} from "../../../redux/slices/persons/personsThunk";
import { getGovernments } from "../../../redux/slices/governments/governmentsThunk";
import { toast } from "react-toastify";
import CustomModal from "../../../components/modal";
import columns from "./columns";
import { getRegions } from "../../../redux/slices/regions/regionsThunk";
import { uploadWholesalerFile } from "../../../redux/slices/importOthers/importPersonsThunk";
import ImportComponent from "../../../components/logModal";

const GrossistesPage = () => {
  const dispatch = useDispatch();
  const persons_data = useSelector((state) => state.persons.persons);
  const persons_loading = useSelector((state) => state.persons.loading);
  const governments_data = useSelector((state) => state.governments.governments);
  const government_loading = useSelector((state) => state.governments.loading);
  const regions_data = useSelector((state) => state.regions.regions);
  const region_loading = useSelector((state) => state.regions.loading);
  const loadingImportation = useSelector((state) => state.uploadOthers.loading);

  const [filter, setFilter] = useState({
    region: [],
    government: [],
  });

  const [ids, setIds] = useState({
    region: [],
    government: [],
  });

  const [search, setSearch] = useState({
    region: "",
    government: "",
    searchTerm: "",
  });

  const [pagination, setPagination] = useState({
    currentPage: 1,
    pageSize: 10,
  });

  const [showLog, setShowLog] = useState(false);
  const [exporting, setExporting] = useState(false);

  const handleShowLog = () => {
    setShowLog(!showLog);
  };

  const handlePageChange = (page, pageSize) => {
    setPagination({ pageSize: pageSize, currentPage: page });
  };

  const [isModalOpen, setIsModalOpen] = useState(false);
  const [itemId, setCitemId] = useState(null);
  const showModal = (id) => {
    setIsModalOpen(true);
    setCitemId(id);
  };

  const refreshGrossistesList = useCallback(() => {
    dispatch(
      getPersonByType({
        type: 3,
        pageNumber: pagination.currentPage,
        limit: pagination.pageSize,
        filter: {
          search: search.searchTerm,
          region: ids.region,
          government: ids.government,
        },
      })
    );
  }, [dispatch, pagination, ids, search.searchTerm]);

  useEffect(() => {
    refreshGrossistesList();
  }, [refreshGrossistesList]);

  useEffect(() => {
    dispatch(getGovernments({ page: 1, limit: 50, search: search.government }));
  }, [search.government, dispatch]);

  useEffect(() => {
    const selectedGovernmentId = ids.government || null;
    dispatch(
      getRegions({
        page: 1,
        itemsPerPage: 50,
        governmentId: selectedGovernmentId,
        search: search.region || "",
      })
    );
  }, [ids.government, search.region, dispatch]);

  const history = useHistory();
  const naviagteTo = (path) => history.push(path);

  const handelDelete = (id) => {
    dispatch(deletePerson(id)).then((result) => {
      if (result.meta.requestStatus === "fulfilled") {
        toast.success("Grossiste supprimé avec succès");
        refreshGrossistesList();
      } else {
        toast.error("Erreur pendant la suppression du grossiste");
      }
    });
    setIsModalOpen(false);
  };

  const createOptions = (data, labelKey = "name", valueKey = "name", idKey = "id") => {
    return (
      data?.map((item) => ({
        id: item[idKey],
        label: item[labelKey],
        value: item[valueKey],
      })) || []
    );
  };

  const optionsLists = [
    {
      name: "Gouvernorat",
      placeholder: "Gouvernorat",
      key: "government",
      multiple: true,
      isLoading: government_loading,
      options: createOptions(governments_data?.data, "name", "name"),
    },
    {
      name: "Région",
      placeholder: "region",
      key: "region",
      multiple: true,
      isLoading: region_loading,
      options: createOptions(regions_data?.data, "name", "name"),
    },
  ];

  const handleSelect = (value, key, id) => {
    setFilter((prevFilter) => ({
      ...prevFilter,
      [key]: Array.isArray(value) ? value : [value],
    }));
    setIds((prevId) => ({
      ...prevId,
      [key]: Array.isArray(id) ? id : [id],
    }));
    setPagination((prevPagination) => ({
      ...prevPagination,
      currentPage: 1,
    }));
  };

  const handleSearchedValue = (value, key) => {
    if (search[key] !== value) {
      setSearch((prevSearch) => ({ ...prevSearch, [key]: value }));
      if (key === "searchTerm")
        setPagination((prevPagination) => ({ ...prevPagination, currentPage: 1 }));
    }
  };

  const handleFileUpload = (file) => {
    const formData = new FormData();
    formData.append("file", file);
    dispatch(uploadWholesalerFile(formData))
      .then((response) => {
        if (response.meta.requestStatus === "fulfilled") {
          toast.success("Fichier importé avec succès");
          refreshGrossistesList();
        } else {
          toast.error("Erreur lors de l'importation du fichier");
        }
      })
      .catch((error) => {
        toast.error("Erreur lors de l'importation du fichier", error);
      });
  };

  const handleExport = () => {
    setExporting(true);
    const currentFilters = {
      search: search.searchTerm,
      region: ids.region,
      government: ids.government,
    };
    dispatch(exportPersons({ type: 3, filter: currentFilters }))
      .then((result) => {
        if (result.meta.requestStatus === "fulfilled") {
          toast.success("Le téléchargement de votre fichier va commencer.");
        } else {
          toast.error(`Erreur lors de l'export: ${result.payload}`);
        }
      })
      .catch(() => {
        toast.error("Une erreur inattendue est survenue lors de l'export.");
      })
      .finally(() => {
        setExporting(false);
      });
  };

  return (
    <div className="tabled">
      <Row gutter={[24, 0]}>
        <Col xs="24" xl={24}>
          <Card
            bordered={false}
            className="criclebox tablespace mb-24"
            title="Liste des grossistes"
            extra={
              <Space>
                <Button shape="circle" icon={ loadingImportation ? (<InfoCircleOutlined style={{ color: 'orange' }} />) : (<InfoCircleOutlined />)} onClick={handleShowLog}/>
                <Upload
                  accept=".csv,.json"
                  customRequest={({ file, onSuccess }) => { handleFileUpload(file); onSuccess(); }}
                  showUploadList={false}
                  disabled={loadingImportation}
                >
                  <Button type="primary" icon={<UploadOutlined />} loading={loadingImportation}>Importer</Button>
                </Upload>
                <Button onClick={handleExport} icon={<DownloadOutlined />} loading={exporting}>Exporter</Button>
                <Button type="primary" onClick={() => naviagteTo("/nouveau/grossiste")}>
                  <PlusOutlined /> Ajouter un grossiste
                </Button>
              </Space>
            }
          />
          <Card
            bordered={false}
            className="criclebox tablespace mb-24"
            title={
              <Filter
                searchPlaceholder="Rechercher"
                optionsLists={optionsLists}
                onSelect={handleSelect}
                onSearchValue={handleSearchedValue}
                data={filter}
              />
            }
          >
            <Table
              columns={columns(naviagteTo, showModal)}
              dataSource={persons_data?.data}
              loading={persons_loading}
              className="ant-border-space"
              rowClassName={(record, index) => index % 2 === 0 ? 'table-row-light' : 'table-row-dark'}
              pagination={{
                current: pagination.currentPage,
                pageSize: pagination.pageSize,
                total: persons_data?.total,
                onChange: handlePageChange,
                showSizeChanger: true,
                pageSizeOptions: ["10", "20", "50"],
                position: ["topRight", "bottomRight"],
              }}
              scroll={{ x: 240 }}
              rowKey={(record) => record.id}
            />
          </Card>
        </Col>
        <CustomModal
          title="Supprimer un grossiste"
          visible={isModalOpen}
          onCancel={() => setIsModalOpen(false)}
          onClose={() => setIsModalOpen(false)}
          action={() => handelDelete(itemId)}
          actionName={"Supprimer"}
          body={"Êtes-vous sûr de vouloir supprimer ce grossiste ?"}
        ></CustomModal>
        <ImportComponent visible={showLog} onCancel={handleShowLog}></ImportComponent>
      </Row>
    </div>
  );
};

export default GrossistesPage;